import { useEffect, useRef, useState } from 'react';

/**
 * TODO: mostly copied/stripped down from `useSliderDrag` in Slider.
 */
export function useDeltaDrag(props) {
  const [isDragging, setIsDragging] = useState(false);
  const refLastStart = useRef([NaN, NaN]);
  useEffect(() => {
    if (!isDragging) return;
    function delta(clientX, clientY) {
      const delta = {
        deltaX: clientX - refLastStart.current[0],
        deltaY: clientY - refLastStart.current[1]
      };
      refLastStart.current = [clientX, clientY];
      return delta;
    }
    function onDrag(e) {
      if (!props.onChange) return;
      const onChange = props.onChange;
      onChange(delta(e.clientX, e.clientY));
    }
    function onDragEnd(e) {
      // only respond to left buttons being lifted
      if (e.button !== 0) return;
      setIsDragging(false);
      const position = delta(e.clientX, e.clientY);
      if (props.onChange) {
        const onChange = props.onChange;
        // NOTE: create a copy to prevent mutation for the onCommit handler
        onChange({
          ...position
        });
      }
      if (props.onCommit) {
        const onCommit = props.onCommit;
        onCommit(position);
      }
    }
    window.addEventListener('mousemove', onDrag);
    window.addEventListener('mouseup', onDragEnd);
    document.addEventListener('mouseleave', onDragEnd);
    return () => {
      window.removeEventListener('mousemove', onDrag);
      window.removeEventListener('mouseup', onDragEnd);
      document.removeEventListener('mouseleave', onDragEnd);
    };
  }, [props.onChange, props.onCommit, isDragging]);
  return {
    startDrag(dragStartClientPos) {
      refLastStart.current = dragStartClientPos;
      setIsDragging(true);
    },
    abortDrag() {
      setIsDragging(false);
    },
    isDragging
  };
}
//# sourceMappingURL=useDeltaDrag.js.map